import { SecurityAccessFeaturesEnum } from 'bff';
import { RouteGuard } from 'components/atoms/route-guard/RouteGuard';
import { RouteBoundary } from 'components/organisms/route-boundary/RouteBoundary';
import { FeatureToggleRoute } from 'modules/app/components/atoms/feature-flags/useFeature';
import { NotFound } from 'modules/app/components/pages/not-found/NotFound';
import InvestmentAndClientInfo from 'modules/clients/components/pages/InvestmentAndClientInfo';
import { ClientDashboard } from 'modules/dashboard/components/pages/clients/ClientDashboard';
import { RouteObject } from 'react-router-dom';
import { routes } from 'routes/route-paths';

export const clientRoutes: RouteObject[] = [
  {
    path: '',
    children: [
      {
        path: '',
        element: (
          <FeatureToggleRoute
            component={
              <RouteGuard
                component={
                  <RouteBoundary>
                    <>
                      <div>Clients page coming soon</div>
                    </>
                  </RouteBoundary>
                }
                features={[SecurityAccessFeaturesEnum.MyClients]}
              />
            }
            fallback={<NotFound />}
            feature='showClient'
          />
        )
      },
      {
        path: routes.clientRoutes.clientDashboard,
        handle: {
          breadcrumb: {
            text: 'Client',
            navigationPath: '/clients/:clientId'
          }
        },

        children: [
          {
            path: '',
            element: (
              <RouteGuard
                component={
                  <RouteBoundary>
                    <ClientDashboard />
                  </RouteBoundary>
                }
                features={[SecurityAccessFeaturesEnum.MyClients]}
              />
            )
          },
          {
            path: routes.clientRoutes.clientChildRoutes.clientProfile,
            handle: {
              breadcrumb: {
                text: 'Investment & client information',
                navigationPath: '/clients/:clientId/client-profile'
              }
            },

            element: (
              <RouteGuard
                component={
                  <RouteBoundary>
                    <InvestmentAndClientInfo />
                  </RouteBoundary>
                }
                features={[SecurityAccessFeaturesEnum.MyClients]}
              />
            )
          }
        ]
      }
    ]
  }
];
